import Index from '@tunnel-components/@pages/tools/extractor/home/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/tools/extractor/home/index.ts